import { createAction } from '@reduxjs/toolkit'

import * as types from './types'

export const backToThePage = createAction(types.SET_PAGINATION)
